import { IVehicleCommon } from './vehicle.interfaces';
import { Action } from '@ngrx/store';
import { Vehicle } from 'src/app/shared/models/vehicle';

export enum VehicleActionTypes {
  FETCH_VEHICLES = '[Vehicle] Fetch Vehicles',
  FETCH_VEHICLES_SUCCESS = '[Vehicle] Fetch Vehicles Success',
  FETCH_VEHICLES_FAILURE = '[Vehicle] Fetch Vehicles Failure',
  ADD_VEHICLE = '[Vehicle] Add Vehicle',
  ADD_VEHICLE_SUCCESS = '[Vehicle] Add Vehicle Success',
  ADD_VEHICLE_FAILURE = '[Vehicle] Add Vehicle Failure',
  DELETE_VEHICLE = '[Vehicle] Delete Vehicle',
  DELETE_VEHICLE_SUCCESS = '[Vehicle] Delete Vehicle Success',
  DELETE_VEHICLE_FAILURE = '[Vehicle] Delete Vehicle Failure',
  UPDATE_VEHICLE = '[Vehicle] Update Vehicle',
  UPDATE_VEHICLE_SUCCESS = '[Vehicle] Update Vehicle Success',
  UPDATE_VEHICLE_FAILURE = '[Vehicle] Update Vehicle Failure',
  REMOVE_ALL_VEHICLES = '[Vehicle] Remove All Vehicles'
}


export class FetchVehicles implements Action {
  readonly type = VehicleActionTypes.FETCH_VEHICLES;
  constructor(public payload: number) {}
}

export class FetchVehiclesSuccess implements Action {
  readonly type = VehicleActionTypes.FETCH_VEHICLES_SUCCESS;
  constructor(public payload: IVehicleCommon[]) {}
}

export class FetchVehiclesFailure implements Action {
  readonly type = VehicleActionTypes.FETCH_VEHICLES_FAILURE;
  constructor(public payload: string) {}
}

export class AddVehicle implements Action {
  readonly type = VehicleActionTypes.ADD_VEHICLE;
  constructor(public payload: Vehicle) {}
}

export class AddVehicleSuccess implements Action {
  readonly type = VehicleActionTypes.ADD_VEHICLE_SUCCESS;
  constructor(public payload: IVehicleCommon) {}
}

export class AddVehicleFailure implements Action {
  readonly type = VehicleActionTypes.ADD_VEHICLE_FAILURE;
  constructor(public payload: string) {}
}

export class DeleteVehicle implements Action {
  readonly type = VehicleActionTypes.DELETE_VEHICLE;
  constructor(public payload: number) {}
}

export class DeleteVehicleSuccess implements Action {
  readonly type = VehicleActionTypes.DELETE_VEHICLE_SUCCESS;
  constructor(public payload: number) {}
}

export class DeleteVehicleFailure implements Action {
  readonly type = VehicleActionTypes.DELETE_VEHICLE_FAILURE;
  constructor(public payload: string) {}
}

export class UpdateVehicle implements Action {
  readonly type = VehicleActionTypes.UPDATE_VEHICLE;
  constructor(public payload: Vehicle) {}
}

export class UpdateVehicleSuccess implements Action {
  readonly type = VehicleActionTypes.UPDATE_VEHICLE_SUCCESS;
  constructor(public payload: IVehicleCommon) {}
}

export class UpdateVehicleFailure implements Action {
  readonly type = VehicleActionTypes.UPDATE_VEHICLE_FAILURE;
  constructor(public payload: string) {}
}

export class RemoveAllVehicles implements Action {
  readonly type = VehicleActionTypes.REMOVE_ALL_VEHICLES;
}

export type VehicleActions = FetchVehicles
| FetchVehiclesFailure
| FetchVehiclesSuccess
| AddVehicle
| AddVehicleSuccess
| AddVehicleFailure
| UpdateVehicle
| UpdateVehicleSuccess
| UpdateVehicleFailure
| RemoveAllVehicles
| DeleteVehicle
| DeleteVehicleSuccess
| DeleteVehicleFailure;
